module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6n7n9n3r-277b7abc8cc1da13048ec779d41d4589.svg";